import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAccessToken } from '~/store/covenants/selectors.ts';
import { selectGuaranteesAdministrationSupervisorInfoByPage } from '~/store/guarantees/selectors.ts';
import { fetchGuaranteesAdministrationSupervisorInfo } from '~/store/guarantees/thunks/applicationThunks.ts';
import { GuaranteesFetchStatus } from '~/store/guarantees/types.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import { supervisorAdministrationPageKeys } from './config.ts';

export const useGuaranteesAdministrationAccessBootstrap = (enabled: boolean) => {
  const dispatch = useAppDispatch();
  const accessToken = useSelector(selectAccessToken);
  const administrationSupervisorInfoByPage = useSelector(
    selectGuaranteesAdministrationSupervisorInfoByPage
  );

  useEffect(() => {
    if (!enabled || !accessToken) {
      return;
    }

    supervisorAdministrationPageKeys.forEach((pageKey) => {
      if (
        administrationSupervisorInfoByPage[pageKey].status !== GuaranteesFetchStatus.Idle
      ) {
        return;
      }

      void dispatch(fetchGuaranteesAdministrationSupervisorInfo({ pageKey }));
    });
  }, [accessToken, administrationSupervisorInfoByPage, dispatch, enabled]);
};
